import { render } from "./AppSkeletonCaseEdit.vue?vue&type=template&id=629f9826&scoped=true&ts=true"
import script from "./AppSkeletonCaseEdit.vue?vue&type=script&lang=ts"
export * from "./AppSkeletonCaseEdit.vue?vue&type=script&lang=ts"

import "./AppSkeletonCaseEdit.vue?vue&type=style&index=0&id=629f9826&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-629f9826"]])

export default __exports__